import { questionnairesTypes } from "../../certificates/const/doc-types.const";
import { DocType } from "../../certificates/models/doc-types.models";

export const REQUEST_DOCUMENT_TOTAL_STEPS = 2;

export const requestQuestionnaireTypes: DocType[] = [
  {
    template: "TQ",
    name: "Technical questionnaire",
    docType: "Questionnaires",
    hasExpirationDate: false,
    hasSurveyDate: false,
  },
  ...questionnairesTypes,
];
